import React, { useEffect, useState } from "react";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { NewsInterface } from "../../News/types";
import { hostName } from "../../../requestMethods";

interface props {
  actuality: NewsInterface;
}

const ToggleImages: React.FC<props> = ({ actuality }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % actuality.images.length);
  };

  const goToPrevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + actuality.images.length) % actuality.images.length
    );
  };

  const [currentImage, setCurrentImage] = useState<any>();

  useEffect(() => {
    actuality.images[currentIndex]
      ? setCurrentImage(actuality.images[currentIndex])
      : setCurrentImage(actuality.images[0]);
  }, [actuality, currentIndex]);

  return (
    <div className="mt-4 flex justify-center items-center">
      {currentImage && (
        <>
          <div className="flex justify-between items-center w-full max-w-3xl">
            {/* Flèche gauche */}
            <FaChevronCircleLeft
              style={{ fontSize: "30px" }}
              className="text-main cursor-pointer hover:text-dark-main transition-colors duration-300"
              onClick={goToPrevSlide}
            />

            {/* Section de l'image */}
            <section className="relative">
              <img
                className="w-80 h-80 object-cover rounded-lg shadow-lg"
                src={hostName + "imgs/News/" + currentImage}
                alt={`img ${currentIndex + 1}`}
              />
            </section>

            {/* Flèche droite */}
            <FaChevronCircleRight
              style={{ fontSize: "30px" }}
              className="text-main cursor-pointer hover:text-dark-main transition-colors duration-300"
              onClick={goToNextSlide}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ToggleImages;
